import * as yup from "yup";

export const CreateOfficeValidationSchema = yup.object().shape({
  name: yup
    .string()
    .required("Required")
    .max(100, "Office Name must be less than 100 characters."),
});
